module.exports = __webpack_public_path__ + "static/media/zeya_shakes_head.894511ad.png";